module.exports = "<div class=\"row\">\r\n  <h1 class=\"page-header\">Кратко о доме</h1>  \r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app-about/app-about.component.html
// module id = 827
// module chunks = 1